import { render } from "./AjoutView.vue?vue&type=template&id=597b7390&scoped=true"
import script from "./AjoutView.vue?vue&type=script&lang=js"
export * from "./AjoutView.vue?vue&type=script&lang=js"

import "./AjoutView.vue?vue&type=style&index=0&id=597b7390&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597b7390"]])

export default __exports__